/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const TabPanel = (props) => {
    
    const {
        children,
        value,
        index,
        ...other
    } = props;
    
    return (
        <div
            role='tabpanel'
            className='link-selector-tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                height: "calc(100% - 115px)"
            }}
        >
            {value === index &&
                <div style={{
                    height: "100%",
                    padding: "0 24px",
                }}
                >
                    {children}
                </div>
            }
        </div>
    );
};

export default TabPanel;
